// Third party imports
import { createSlice } from "@reduxjs/toolkit";

export const clientBoardSlice = createSlice({
  name: "clientBoard",
  initialState: {
    services: [],
    selectedService: null,
    tasks: [],
    selectedTask: null,
    subtasks: [],
    selectedSubTask: null,
    labels: [],
  },
  reducers: {
    setServices: (state, action) => {
      state.services = action.payload;
    },
    setSelectedService: (state, action) => {
      state.selectedService = action.payload;
    },
    clearSelectedService: (state) => {
      state.selectedService = null;
    },
    clearServices: (state) => {
      state.services = [];
    },
    setTasks: (state, action) => {
      state.tasks = action.payload;
    },
    setSelectedTask: (state, action) => {
      state.selectedTask = action.payload;
    },
    clearSelectedTask: (state) => {
      state.selectedTask = null;
    },
    clearTasks: (state) => {
      state.tasks = [];
    },
    setSubtasks: (state, action) => {
      state.subtasks = action.payload;
    },
    clearSubTasks: (state) => {
      state.subtasks = [];
    },
    setSelectedSubTask: (state, action) => {
      state.selectedSubTask = action.payload;
    },
    clearSelectedSubTask: (state) => {
      state.selectedSubTask = null;
    },
    setLabels: (state, action) => {
      state.labels = action.payload;
    },
    clearLabels: (state) => {
      state.labels = [];
    },
    updateSubtask: (state, action) => {
      const index = state.subtasks.findIndex(
        (subtask) => subtask.id === action.payload.id
      );
      if (index !== -1) {
        state.subtasks[index] = action.payload;
      } else {
        // If subtask is not in the list, add it (for activation case)
        state.subtasks.push(action.payload);
      }
      // Also update selectedSubTask if it's the same subtask
      if (state.selectedSubTask?.id === action.payload.id) {
        state.selectedSubTask = action.payload;
      }
    },
    removeSubtask: (state, action) => {
      state.subtasks = state.subtasks.filter(
        (subtask) => subtask.id !== action.payload
      );
      // Clear selected subtask if it was removed
      if (state.selectedSubTask?.id === action.payload) {
        state.selectedSubTask = null;
      }
    },
    updateTask: (state, action) => {
      const index = state.tasks.findIndex(
        (task) => task.id === action.payload.id
      );
      if (index !== -1) {
        state.tasks[index] = action.payload;
      } else {
        // If task is not in the list, add it (for activation case)
        state.tasks.push(action.payload);
      }
      // Also update selectedTask if it's the same task
      if (state.selectedTask?.id === action.payload.id) {
        state.selectedTask = action.payload;
      }
    },
    removeTask: (state, action) => {
      state.tasks = state.tasks.filter(
        (task) => task.id !== action.payload
      );
      // Clear selected task if it was removed
      if (state.selectedTask?.id === action.payload) {
        state.selectedTask = null;
      }
    },
    updateService: (state, action) => {
      const index = state.services.findIndex(
        (service) => service.id === action.payload.id
      );
      if (index !== -1) {
        state.services[index] = action.payload;
      }
      // Also update selectedService if it's the same service
      if (state.selectedService?.id === action.payload.id) {
        state.selectedService = action.payload;
      }
    },
    removeService: (state, action) => {
      state.services = state.services.filter(
        (service) => service.id !== action.payload
      );
      // Clear selected service if it was removed
      if (state.selectedService?.id === action.payload) {
        state.selectedService = null;
      }
    },
  },
});
export const {
  setServices,
  setSelectedService,
  clearSelectedService,
  clearServices,
  setTasks,
  setSelectedTask,
  clearSelectedTask,
  clearTasks,
  setSubtasks,
  clearSubTasks,
  setSelectedSubTask,
  clearSelectedSubTask,
  setLabels,
  clearLabels,
  updateSubtask,
  removeSubtask,
  updateTask,
  removeTask,
  updateService,
  removeService,
} = clientBoardSlice.actions;
export default clientBoardSlice.reducer;
